import { Ticket as Ticket_kojaro } from './Ticket.kojaro';
import { Ticket as Ticket_phosphor } from './Ticket.phosphor';
import { Ticket as Ticket_zoomg } from './Ticket.zoomg';
import { Ticket as Ticket_zoomit } from './Ticket.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Ticket_kojaro;

    case 'zoomg':
      return Ticket_zoomg;

    case 'phosphor':
      return Ticket_phosphor;

    default:
      return Ticket_zoomit;
  }
};

export const Ticket = IconRenderer();
